import { ObjectSchema, object, string, boolean } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { ApprovalReason, ApprovalRequest } from './../../models/approval-request';

export const approvalReasonOtherLength = 200;
export const approvalReasonCommentLength = 400;

yup.setLocale(locale);

export function approvalRequestValidator(): ObjectSchema<ApprovalRequest> {
    return object({
        shipyardId: string().uuid().required().nonNullable().strict(),
        vesselId: string().uuid().required().nonNullable().strict(),
        vesselName: string().required().nonNullable().strict(),
        approverName: string().required().nonNullable().strict(),
        approverEmail: string().email().required().nonNullable().strict(),
        approverOid: string().required().nonNullable().strict(),
        ownerName: string().required().nonNullable().strict(),
        ownerEmail: string().email().required().nonNullable().strict(),
        ownerOid: string().required().nonNullable().strict(),
        version: string().required().nonNullable().strict(),
        reason: approvalReasonValidator().strict().required().noUnknown(),
    })
        .strict()
        .noUnknown() as ObjectSchema<ApprovalRequest>;
}

export function approvalReasonValidator(): ObjectSchema<ApprovalReason> {
    return object({
        customerRequest: boolean().required().nonNullable().strict(),
        misconfiguration: boolean().required().nonNullable().strict(),
        internalRequest: boolean().required().nonNullable().strict(),
        other: string().nullable().required().strict().max(approvalReasonOtherLength),
        comment: string().nullable().strict().max(approvalReasonCommentLength),
    })
        .strict()
        .noUnknown();
}
